import React from 'react'

function MechanisItem ({list, current}) {
    const doSelect = (index) => {
        current(index)
    }
    return (
        list.map((item, index) => {
            return (
                <li className={`lx-default ${item.isActive? 'active': ''}`} key={index} onClick={doSelect.bind(this, index)}>
                    <div className="inner lx-text-center lx-flex-row-center">
                        <span className="title lx-fz16">{ item.title }</span>
                    </div>
                </li>
            )
        })
    ) 
}

export default MechanisItem;